var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMailIcon = function SvgMailIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18 4.5a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2zm.244 2.162-6.585 5.762-.098.075a1 1 0 0 1-1.111.007l-.108-.082-6.586-5.762c-.135.2-.223.433-.248.685L3.5 7.5v8a1.5 1.5 0 0 0 1.356 1.493L5 17h12a1.5 1.5 0 0 0 1.493-1.355l.007-.145v-8c0-.259-.066-.502-.18-.714zM17 6H5l5.68 4.733a.5.5 0 0 0 .567.051l.073-.05z",
    clipRule: "evenodd"
  })));
};
export default SvgMailIcon;